import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import ModalImage from 'shared/components/common/custom_image_lightbox/ModalImage';

export default function ShopifyProductView({ show, product, handleClose }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    if (!product) return null;

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered scrollable>
            <Modal.Header className={styles.Header}>
                <div className="d-flex justify-content-between align-items-center w-100">
                    <Heading heading={product.title} headingStyle={styles.AddLinkHeading} />
                    <span className={classNames(styles.Badge, product.status === 'active' ? styles.BadgeActive : styles.BadgeDraft)}>
                        {product.status}
                    </span>
                </div>
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={styles.MainInfo}>
                    <div className={styles.InfoItem}>
                        <span className={styles.Label}>Base SKU</span>
                        <span className={styles.Value}>{product.base_sku || 'N/A'}</span>
                    </div>
                    <div className={styles.InfoItem}>
                        <span className={styles.Label}>Vendor</span>
                        <span className={styles.Value}>{product.vendor}</span>
                    </div>
                    <div className={styles.InfoItem}>
                        <span className={styles.Label}>Product Type</span>
                        <span className={styles.Value}>{product.product_type}</span>
                    </div>
                    <div className={styles.InfoItem}>
                        <span className={styles.Label}>External ID</span>
                        <span className={styles.Value}>{product.external_id}</span>
                    </div>
                </div>

                {product.images && product.images.length > 0 && (
                    <>
                        <h6 className={styles.SectionTitle}>Images</h6>
                        <div className={styles.ImageGallery}>
                            {product.images.map((img, idx) => (
                                <div key={idx} className={styles.ImageWrapper}>
                                    <ModalImage
                                        small={img}
                                        large={img}
                                        alt={`${product.title}-${idx}`}
                                        className={styles.ProductImage}
                                        imageArray={product.images}
                                        currentIndex={idx}
                                    />
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {product.description_html && (
                    <>
                        <h6 className={styles.SectionTitle}>Description</h6>
                        <div className={styles.DescriptionContainer}>
                            <div
                                className={styles.HtmlContent}
                                dangerouslySetInnerHTML={{ __html: product.description_html }}
                            />
                        </div>
                    </>
                )}

                {product.variants && product.variants.length > 0 && (
                    <>
                        <h6 className={styles.SectionTitle}>Variants & Stock</h6>
                        {product.variants.map((variant, idx) => (
                            <div key={variant.sku || idx} className={styles.VariantCard}>
                                <div className={styles.VariantHeader}>
                                    <span>{variant.color || 'Default Variant'}</span>
                                    <span>{variant.sku}</span>
                                </div>
                                <div className={styles.VariantDetails}>
                                    <div>
                                        <span className={styles.Label}>Price</span>
                                        <span className={styles.Value}>Rs {variant.price}</span>
                                    </div>
                                    <div>
                                        <span className={styles.Label}>Total Qty</span>
                                        <span className={styles.Value}>{variant.total_quantity}</span>
                                    </div>
                                </div>
                                {variant.inventory && variant.inventory.length > 0 && (
                                    <div className={styles.InventoryList}>
                                        <span className={styles.Label} style={{ fontSize: '0.8rem' }}>Warehouse Stock:</span>
                                        {variant.inventory.map((inv, i) => (
                                            <div key={i} className={styles.InventoryItem}>
                                                <span>{inv.warehouse_id}:</span>
                                                <span className="fw-bold">{inv.quantity}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </>
                )}

                <div className="d-flex justify-content-end">
                    <CustomButton text={'Close'} containerStyle={styles.CloseBtn} submitHandle={handleClose} />
                </div>
            </Modal.Body>
        </Modal>
    );
}
